module.exports = __webpack_public_path__ + "static/media/resume 1.41ffbff5.jpg";